import { registerPlugin } from '@capacitor/core';
export const _Notificare = registerPlugin('NotificarePlugin', {
    web: () => import('./web').then((m) => new m.NotificarePluginWeb()),
});
//# sourceMappingURL=plugin.js.map